<template>
  <div
    v-if="showLoading"
    class="o-login"
  >
    <AtomLoadingPrimary :loading-text="$t('mLogin.message')"/>
  </div>
  <div
    v-else
  >
    <div
      v-if="licenciaActiva"
      class="o-login"
    >
      <MoleculeLogin/>
    </div>
    <div
      v-else
      class="o-login"
    >
      <MoleculeLoginDisabled :licencia-publica-detallada="licenciaPublicaDetallada" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrganismLogin',

  data () {
    return {
      licenciaPublicaDetallada: {},

      licenciaActiva: false,
      showLoading: true
    }
  },

  created () {
    this.readLicenciaPublicaDetallada()
  },

  components: {
    MoleculeLogin: () => import('@/components/molecules/MoleculeLogin'),
    MoleculeLoginDisabled: () => import('@/components/molecules/MoleculeLoginDisabled')
  },

  methods: {
    readLicenciaPublicaDetallada () {
      this.$services.read('licencia', 'readLicenciaPublicaDetallada', {}, [this.$route.params.id])
        .then(response => {
          this.licenciaPublicaDetallada = response.data
          if (this.licenciaPublicaDetallada.licencia_activa || this.licenciaPublicaDetallada.academia_vidroop) {
            this.licenciaActiva = true
          } else {
            this.licenciaActiva = false
          }
          this.showLoading = false
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>
